import {sma, ema, VWAP} from 'technicalindicators';




export const calSMA =  (data, source, length, ticker) => {
    let d1 = data[0][ticker].map((d) => d[source]);
    const calSMA =  sma({period : length, values : d1})
    const diff = d1.length - calSMA.length;
    const emptyArray = [...new Array(diff)].map((d) => '');
    const d3 = [...emptyArray, ...calSMA];
    d1 = data[0][ticker].map((d, i) => ({ ...d, [`sma${length}`]: d3[i] }));
    data[0][ticker] = d1
    return data;
};

export const calEMA =  (data, source, length, ticker) => {
    let d1 = data[0][ticker].map((d) => d[source]);
    const calEMA =  ema({period : length, values : d1})
    const diff = d1.length - calEMA.length;
    const emptyArray = [...new Array(diff)].map((d) => '');
    const d3 = [...emptyArray, ...calEMA];
    d1 = data[0][ticker].map((d, i) => ({ ...d, [`ema${length}`]: d3[i] }));
    data[0][ticker] = d1
    return data;
};

export const calVWAP =  (data,  ticker) => {

    let close = data[0][ticker].map((d) => d['adjusted_close']);
    let high = data[0][ticker].map((d) => d['adjusted_high']);
    let low = data[0][ticker].map((d) => d['adjusted_low']);
    let volume = data[0][ticker].map((d) => d['volume']);


    const inputVWAP = {
        open : [],
        high : high,
        low : low,
        close : close,
        volume : volume,
    };

    const vwap = new VWAP(inputVWAP);
    let d1 = vwap.getResult()
    d1 = data[0][ticker].map((d, i) => ({ ...d, ['vwap']: d1[i] }));
    data[0][ticker] = d1
    return data;
};

